import type { PublicDisplaySnapshot } from "./shared/types";

export async function fetchSnapshot(): Promise<PublicDisplaySnapshot> {
  const response = await fetch("/api/display/snapshot", {
    cache: "no-store",
    headers: {
      accept: "application/json",
      "cache-control": "no-cache"
    }
  });

  if (!response.ok) {
    throw new Error(`Snapshot request failed: ${response.status}`);
  }

  return (await response.json()) as PublicDisplaySnapshot;
}

export async function loginAdmin(password: string): Promise<{ ok: boolean; sessionToken: string }> {
  const response = await fetch("/api/admin/login", {
    method: "POST",
    headers: {
      "content-type": "application/json"
    },
    body: JSON.stringify({ password })
  });

  if (!response.ok) {
    throw new Error(`Admin login failed: ${response.status}`);
  }

  return (await response.json()) as { ok: boolean; sessionToken: string };
}

export async function changeAdminPassword(token: string, currentPassword: string, newPassword: string): Promise<{ ok: boolean }> {
  return postAdminJson("/api/admin/password", token, { currentPassword, newPassword });
}

export async function postAdminJson<TResponse>(path: string, token: string, body: unknown): Promise<TResponse> {
  const response = await fetch(path, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      authorization: `Bearer ${token}`
    },
    body: JSON.stringify(body)
  });

  if (!response.ok) {
    throw new Error(`Admin request failed: ${response.status}`);
  }

  return (await response.json()) as TResponse;
}

export async function fetchAdminJson<TResponse>(path: string, token: string): Promise<TResponse> {
  const response = await fetch(path, {
    headers: {
      accept: "application/json",
      authorization: `Bearer ${token}`
    }
  });

  if (!response.ok) {
    throw new Error(`Admin request failed: ${response.status}`);
  }

  return (await response.json()) as TResponse;
}
